// extracted by mini-css-extract-plugin
module.exports = {"categoryLink":"categoryLink_categoryLink__MavMR","onDark":"categoryLink_onDark__1DK41","small":"categoryLink_small__g42Jt","large":"categoryLink_large__ra5KP"};